module.exports = __webpack_public_path__ + "1.5.0-unryo/img/logo.ddeb5c82.svg";